import { render } from "./Block.vue?vue&type=template&id=5290632f&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=5290632f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5290632f"

export default script